module.exports = "/virtual-football-league/img/video/clubs/france/marseille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/france/marseille.png
// module id = 341
// module chunks = 4